import { render, staticRenderFns } from "./EditPhone.vue?vue&type=template&id=0f32d7e2&scoped=true&"
import script from "./EditPhone.vue?vue&type=script&lang=js&"
export * from "./EditPhone.vue?vue&type=script&lang=js&"
import style0 from "./EditPhone.vue?vue&type=style&index=0&id=0f32d7e2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f32d7e2",
  null
  
)

export default component.exports